//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
  VIDFLEET_CONFIGURATION_LOAD,
  VIDFLEET_CONFIGURATION_SAVE,
  VIDFLEET_CONFIGURATION_GET_DEVICE_INFO,
  VIDFLEET_CONFIGURATION_SETTINGS_TO_CLONE
} from 'Redux/actionTypes';

//```import global actions
import {
  vidfleetConfigurationLoadDataResult,
  vidfleetConfigurationSaveResult,
  vidfleetConfigurationGetDeviceDataResult,
  vidfleetConfigurationSettingsToCloneResult
} from 'Redux/actions';

/**
 * Method for get customer data for Server
 * @param {object} payload Payload with info
 */
function* vidfleetConfigurationLoad({ payload }) {
  try {

    const headers = {
      'Content-Type': 'application/json'
    };

    let result = {}
    let { deviceESN, devices } = payload;
    let data = null;

    //get fleet configuration

    let QUERY_FLEET_CONFIG = `
      query getFleetDefaultConfigure {
        result: getFleetDefaultConfigure
      }
    `
    let fleetConfig = yield call(
      clientQuery,
      QUERY_FLEET_CONFIG,
      {},
      endpoints.GRAPHQL_GENERAL,
    );

    if (fleetConfig?.result) {
      try {
        let resultFleetConfig = JSON.parse(fleetConfig?.result);
        result.fleetConfigValue = resultFleetConfig;
      } catch (error) { }
    }

    let QUERY_DEFAULT_CONFIG = `
      query getCamerasDefaultConfigure {
        result: getCamerasDefaultConfigure
      }
    `
    let fleetDefaultConfig = yield call(
      clientQuery,
      QUERY_DEFAULT_CONFIG,
      {},
      endpoints.GRAPHQL_GENERAL,
    );

    if (fleetDefaultConfig?.result) {
      let resultFleetDefaultConfig = JSON.parse(fleetDefaultConfig?.result)
      result.defaultConfigValue = resultFleetDefaultConfig;
    }

    if (deviceESN) {

      let QUERY_CAMERA_CONFIG = `
        query getCameraConfiguration($esn: String!) {
          result: getCameraConfiguration(esn:$esn)
        }
      `
      let cameraConfig = yield call(
        clientQuery,
        QUERY_CAMERA_CONFIG,
        {
          esn: deviceESN
        },
        endpoints.GRAPHQL_GENERAL,
      );

      if (cameraConfig.result) {
        try {
          let resultCameraConfig = JSON.parse(cameraConfig.result)
          result.deviceConfigValue = {
            settings: resultCameraConfig
          }
        } catch (error) { }
      }
    }

    //restricted allowed configuration config combinations
    let QUERY_SUPPORTED_COMBINATIONS = `
      query getSupportedPropertiesCombinations {
        result: getSupportedPropertiesCombinations
      }
    `
    let supportedPropertiesCombinations = yield call(
      clientQuery,
      QUERY_SUPPORTED_COMBINATIONS,
      {},
      endpoints.GRAPHQL_GENERAL,
    );

    if (supportedPropertiesCombinations.result) {
      let resultSupportedPropertiesCombinations = JSON.parse(supportedPropertiesCombinations.result)
      result.restrictedConfigureProperties = resultSupportedPropertiesCombinations;
    }

    //timezones ids
    let QUERY_TIMEZONE = `
      query getTimezonesSupported {
        result: getTimezonesSupported
      }
    `

    let dataTimezone = yield call(
      clientQuery,
      QUERY_TIMEZONE,
      {},
      endpoints.GRAPHQL_GENERAL,
    );

    let timezones = [];
    if (dataTimezone.result) {
      try {
        let resultTimezones = JSON.parse(dataTimezone.result)
        if (resultTimezones.length > 0) {
          resultTimezones.map((tz, index) => {
            timezones.push({ id: tz, label: tz });
          })
        }
      } catch (error) { }
    }
    result.timezones = timezones;

    const QUERY = `
            query ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int){
              Devices: searchUnits(conditions: $conditions sort: $sort limit: $limit offset: $offset ){
                Total
                Items {
                  id
                  name
                  imei
                  esn
                  deviceModel {
                    id
                    name
                    manufacturer {
                        id
                        nametag
                    }
                  }
                  configStatus
                  unitConfig {
                    unitId
                    configVersion
                    scriptVersion
                    pulsCustomerId
                    pulsGroup
                    movingFrequency
                    stoppedFrequency
                    password
                    cameraInfo
                    cameraInfoUpdated
                    simState
                    firmwareId
                    hardwareVersion
                    cameraConfig
                    }
                }
              }
            }
            `;

    if (devices?.length > 0) {
      let ids = []
      devices.map((item, posc) => {
        ids.push(item.Id);
      })
      let criteria = {
        conditions: [
          { terms: ids, fields: ["id"], exact: true },
        ],
        offset: 0,
        limit: devices.length
      };


      const dataDevices = yield call(
        clientQuery,
        QUERY,
        criteria,
        endpoints.GRAPHQL_GENERAL
      );

      result.devices = dataDevices.Devices.Items
    } else {
      result.devices = [];
    }


    yield put(vidfleetConfigurationLoadDataResult(result))
  } catch (exc) {

    //```call action for return
    yield put(vidfleetConfigurationLoadDataResult({ error: exc }));

    //```catch error
    ExceptionManager(exc,
      "Modules/vidfleet/.components/configuration/redux/saga/",
      "vidfleetConfigurationLoad")
  }
}

function* vidfleetConfigurationSave({ payload }) {

  try {

    const headers = {
      'Content-Type': 'application/json'
    };
    let { config, deviceId, devices, applyScopes, bulk, verificationCode } = payload;

    let result = null;
    let data = null;
    let QUERY = `
            mutation updateVidFleetAddConfig ($settings: AWSJSON!, $scopes: [enumVidFleetScope]!, $unitIds: [Int]!, $verificationCode: String) {
            result: updateVidFleetAddConfig (settings: $settings, scopes: $scopes, unitIds: $unitIds, verificationCode: $verificationCode)
            }
          `;

    if (bulk) {

      let cameras = [];
      if (devices.length > 0) {
        devices.forEach(device => {
          cameras.push(device.id);
        });
      }

      data = yield call(
        clientMutation,
        QUERY,
        {
          settings: JSON.stringify(config),
          scopes: applyScopes,
          unitIds: cameras,
          verificationCode: verificationCode
        },
        endpoints.GRAPHQL_GENERAL,
      );

    } else {

      if (deviceId) {

        data = yield call(
          clientMutation,
          QUERY,
          {
            settings: JSON.stringify(config),
            scopes: ["Partial"],
            unitIds: [deviceId]
          },
          endpoints.GRAPHQL_GENERAL,
        );

      } else {

        QUERY = `
          mutation updateVidFleetAddConfig ($settings: AWSJSON!, $scopes: [enumVidFleetScope]!, $unitIds: [Int]!, $verificationCode: String) {
            result: updateVidFleetAddConfig (settings: $settings, scopes: $scopes, unitIds: $unitIds, verificationCode: $verificationCode)
          }
        `;

        data = yield call(
          clientMutation,
          QUERY,
          {
            settings: JSON.stringify(config),
            scopes: ["Default"],
            unitIds: [],
            verificationCode: verificationCode
          },
          endpoints.GRAPHQL_GENERAL,
        );

      }
    }
    yield put(vidfleetConfigurationSaveResult(data));
  } catch (exc) {

    yield put(vidfleetConfigurationSaveResult({ error: exc }));
    ExceptionManager(exc, "Modules/vidfleet/.components/configuration/redux/saga/", "vidfleetConfigurationSave", false);

  }
}

function* vidFleetGetDeviceInfo({ payload }) {
  try {

    let { deviceESN } = payload;
    if (deviceESN) {

      let QUERY = `
        query getCameraInfo($esn: String!) {
          result: getCameraInfo(esn:$esn)
        }
      `
      let data = yield call(
        clientQuery,
        QUERY,
        {
          esn: deviceESN
        },
        endpoints.GRAPHQL_GENERAL,
      );

      if (data.result) {
        try {
          let result = JSON.parse(data.result)
          if (result.id) {
            yield put(vidfleetConfigurationGetDeviceDataResult(result))
          } else {
            yield put(vidfleetConfigurationGetDeviceDataResult({}))
          }
        } catch (error) {
          yield put(vidfleetConfigurationGetDeviceDataResult({}))
        }
      } else {
        yield put(vidfleetConfigurationGetDeviceDataResult({}))
      }
    }

  } catch (exc) {
    yield put(vidfleetConfigurationGetDeviceDataResult({ error: exc }))


    ExceptionManager(
      exc,
      "Modules/vidfleet/.components/configuration/redux/saga/",
      "vidFleetConfigurationGetDeviceInfo"
    );
  }
}

function* loadSettingsToClone({ payload }) {

  try {

    let { serialEsn } = payload;

    //load the configuration to clone
    let QUERY_CAMERA_CONFIG = `
      query getCameraConfiguration($esn: String!) {
        result: getCameraConfiguration(esn:$esn)
      }
    `;

    let cameraConfig = yield call(
      clientQuery,
      QUERY_CAMERA_CONFIG,
      {
        esn: serialEsn
      },
      endpoints.GRAPHQL_GENERAL,
    );

    if (cameraConfig.result) {
      try {
        let resultCameraConfig = JSON.parse(cameraConfig.result)
        yield put(vidfleetConfigurationSettingsToCloneResult({ settings: resultCameraConfig }));
      } catch (error) { }
    }else{
      yield put(vidfleetConfigurationSettingsToCloneResult({ settings: null, error: true, msg: "vidfleet_configuration_no_configuration_found" }));
    }
  } catch (exc) {
    //```always return empty data
    if (exc.request && exc.request.response) {
      let errorResponse = JSON.parse(exc.request.response)
      yield put(vidfleetConfigurationSettingsToCloneResult({ error: errorResponse }));
    } else
      yield put(vidfleetConfigurationSettingsToCloneResult({ error: exc }));



    //```catch error
    ExceptionManager(exc, "Modules/devices/components/bulkVidFleetConfig/redux/saga/", "loadSettingsToClone");
  }
}

export const getDevices = async (input = '') => {
  try {
    let QUERY = `
      query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
          result: searchUnits (conditions: $conditions sort: $sort limit: $limit offset: $offset) {
              items {
                  id
                  label
                  esn
                  deviceModel {
                    id
                    name
                    manufacturer {
                        id
                        name
                    }
                  }
              }
          }
      }`
    return await clientQuery(QUERY, {
      conditions: [
        {
          fields: [
            "label", "esn", "imei"
          ],
          terms: [
            input
          ],
          exact: false
        },
        {
          fields: [
            "deviceModel_manufacturer_name"
          ],
          terms: [
            "VidFleet"
          ],
          exact: true
        }

      ],
      limit: 10
    }, endpoints.GRAPHQL_GENERAL);
  } catch (exc) {
    ExceptionManager(exc, 'Modules/vidfleet/.components/configuration/redux/saga', 'getDevices');
  }
}

function* watchMethods() {
  yield takeEvery(VIDFLEET_CONFIGURATION_LOAD, vidfleetConfigurationLoad);
  yield takeEvery(VIDFLEET_CONFIGURATION_SAVE, vidfleetConfigurationSave);
  yield takeEvery(VIDFLEET_CONFIGURATION_GET_DEVICE_INFO, vidFleetGetDeviceInfo);
  yield takeEvery(VIDFLEET_CONFIGURATION_SETTINGS_TO_CLONE, loadSettingsToClone);
}

/**
 * Export for global saga
 */
export default function* rootSaga() {
  yield all([fork(watchMethods)]);
}